const detectingClassesInSourceFiles = {
  name: "Detecting classes in source files",
  path: "detecting-classes-in-source-files",
  title: "Detecting Classes in Source Files",
  description: "Understanding and customizing how Unicss scans your source files.",
  heading: false,
  exampleData: [
    {
      "title": "Overview",
      "description": "",
      "moreDescription": "Unicss has been designed from the ground up to be extensible and customizable, so that no matter what you’re building you never feel like you’re fighting the framework.",
      "parentClass": "!bg-none !border-0",
      "example": {
        "element": "div",
        "className": "relative",
      }
    },
    {
      "title": "How classes are detected",
      "moreDescription": "Unicss treats all of your source files as plain text, and doesn't attempt to actually parse your files as code in any way. Instead it just looks for any tokens in your file that could be classes based on which characters Unicss is expecting in class names:",
      "parentClass": "!bg-none !border-0",
      "example": {
        "element": "div",
        "className": "relative",
      }
    },
    {
      "title": "Don't construct class names dynamically",
      "moreDescription": "In the example below, the strings text-color-red-600 and text-color-green-600 do not exist, so Unicss will not generate those classes.",
      "parentClass": "!bg-none !border-0",
      "example": {
        "element": "div",
        "className": "relative",
        "code":`<div class="text-color-{{ error ? 'red' : 'green' }}-600"></div>`
      }
    },
     {
      "title": "Always use complete class names",
      "moreDescription": "",
      "parentClass": "!bg-none !border-0",
      "example": {
        "element": "div",
        "className": "relative",
        "code":`<div class="{{ error ? 'text-red-600' : 'text-green-600' }}"></div>`
      }
    },
  ]
};

export default detectingClassesInSourceFiles;
